var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"lb"},_vm._l((_vm.lb),function(v,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.lb&&_vm.index==i),expression:"lb&&index==i"}],key:v.id,staticClass:"item",style:({backgroundImage:'url('+_vm.picurl+v.pic+')'})})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f94a3c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other/test.vue
// module id = null
// module chunks = 